module.exports = __webpack_public_path__ + "img/download-v2.109ce71b.svg";